import { FunctionComponent, useEffect } from "react";
import "../news.scss";
import DIV from "../../shared/html-tags/div";

export type Props = {
  postLink: string | undefined;
  setNewsPostTitle: (title: string) => void;
};

const NewsPSImagoPro10: FunctionComponent<Props> = (props) => {
  useEffect(() => {
    const postLink = "ps-imago-pro-10";
    const postTitle = "PS IMAGO PRO 10 /// WHAT'S NEW";

    if (props.postLink === postLink) {
      const setNewsPostTitle = props.setNewsPostTitle;
      setNewsPostTitle(postTitle);
    }
  }, [props.postLink, props.setNewsPostTitle]);

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      {props.postLink === "ps-imago-pro-10" && (
        <>
          <DIV language="de" className="news-post">
            <h2>NEUE PREDICTIVE SOLUTIONS-FUNKTIONEN</h2>
            <h3>Neue Fenster für Predictive Solutions-Verfahren</h3>
            Für alle 66 Verfahren, einschließlich 5 neuen, wurden neue
            Dialogfenster vorbereitet, die jetzt unter anderem folgendes bieten:
            <ul>
              <li>
                Variablen alphabetisch, absteigend, aufsteigend oder nach dem
                zugewiesenen Messniveau sortieren.
              </li>
              <li>
                Schneller Wechsel zwischen Variablennamen und Beschriftungen.
              </li>
              <li>Variablenauswahl basierend auf dem Messniveau.</li>
              <li>
                Die Möglichkeit, alle im Verfahren verfügbaren Variablen über
                die Fensteroberfläche auszuwählen.
              </li>
              <li>
                Anzeige, welche Felder des Verfahrens erforderlich sind.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/split-data.png"
                  alt="Dialog 'Daten aufteilen'"
                  style={{ width: "min(84vw, 50rem)", margin: "2rem 0 4rem 0" }}
                />
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>Neue Visualisierungstypen der Ergebnisse</h3>
            <ul>
              <li>
                <b>SKALENGRAPH</b>
                <br />– ein spezieller Balkendiagrammtyp, der für Merkmale
                verwendet wird, die auf derselben Skala gemessen werden. Dieser
                Visualisierungstyp kann eingesetzt werden, wenn du eine Reihe
                von Merkmalen in einem einzigen Diagramm darstellen möchtest,
                die polarisierte Werte aufweisen, wie etwa „ja“ und „nein“, oder
                wenn die Skala umfangreicher ist und beispielsweise von „stimme
                voll zu“ bis „lehne stark ab“ reicht. Er kann sowohl für
                ungerade Skalen mit einer zentralen (neutralen) Position als
                auch für gerade Skalen verwendet werden. Dieser
                Visualisierungstyp ist nützlich, um Daten darzustellen, die aus
                Skalen wie Likert-Skalen, semantischen Differentialen oder
                Stapel-Skalen abgeleitet wurden.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/scale-graph.png"
                  alt="Skalengraph"
                  style={{ width: "min(84vw, 50rem)", margin: "1rem 0 4rem 0" }}
                />
              </li>
              <li>
                <b>KORRELATIONSKARTE</b>
                <br />– Diese Visualisierung wird verwendet, um die Beziehungen
                zwischen mehreren Merkmals-Paaren in einem einzigen Diagramm
                darzustellen, was die Analyse der Zusammenhänge zwischen einer
                großen Anzahl von Variablen erleichtert. Die Stärke der
                Beziehung zwischen Merkmals-Paaren wird mittels Farbsättigung
                oder eines Rot-Grün-Verlaufs dargestellt. Zur leichteren
                Interpretation kannst du im Diagramm
                Korrelationskoeffizientenwerte, Variablenanzahlen und
                Signifikanzniveaus anzeigen. Das Verfahren ermöglicht die
                Darstellung eines von vier Korrelationsmaßen: Pearsons r,
                r-Quadrat, Kendalls Tau-b oder Spearmans rho. Du kannst einen
                Schwellenwert für das Signifikanzniveau festlegen, um
                statistisch insignifikante Beziehungen zwischen Variablenpaaren
                einfach herauszufiltern.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/correlation-map.png"
                  alt="Korrelationskarte"
                  style={{ width: "min(84vw, 50rem)", margin: "1rem 0 4rem 0" }}
                />
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>Neue Verfahren zur Datenaufbereitung</h3>
            <ul>
              <li>
                <b>DATEN AUFTEILEN</b> – ermöglicht es, einen Datensatz in
                mehrere Teilmengen zu unterteilen, ohne die mühsame Auswahl von
                Datenuntergruppen und das separate Speichern jeder
                Untergruppendatei. Zum Beispiel, wenn du die Daten nach Regionen
                aufteilen möchtest, gibst du einfach das Merkmal „Region“ an,
                führst das Verfahren aus, und neue Datendateien werden am
                angegebenen Ort erstellt. Jede Datei repräsentiert Daten aus
                einer Region, gespeichert im .sav-Format. Das Verfahren
                ermöglicht eine flexible Verwaltung der Dateinamen basierend auf
                Beschriftungsnamen und Werten oder deinen Präferenzen.
              </li>
              <li>
                <b>TEXT AUFTEILEN</b> – ermöglicht es, eine einzelne
                Textvariable in mehrere neue Variablen aufzuteilen. Dies ist
                besonders nützlich, wenn in einem Datensatz eine Variable mehr
                als einen Wert enthalten kann, beispielsweise eine Liste
                kürzlich gekaufter Produkte, getrennt durch Kommas. Das
                Aufteilen von Textvariablen kann auf zwei Arten erfolgen. Die
                erste Methode teilt die Variable anhand eines von dir
                angegebenen Zeichens oder eines benutzerdefinierten Textstrings
                auf. Die zweite Option teilt die Variable anhand einer festen
                Breite auf. Das Verfahren erstellt neue Variablen mit Namen, die
                aus dem von dir festgelegten Präfix und einem Zähler bestehen.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/split-text.png"
                  alt="Dialog 'Text aufteilen'"
                  style={{ width: "min(84vw, 60rem)", margin: "2rem 0 4rem 0" }}
                />
              </li>
              <li>
                <b>STRING ZÄHLEN</b>
                <br />– Diese Funktion ist nützlich, um die Antworten von
                Befragten aus offenen Fragen oder anderen Texten zu analysieren
                und die Häufigkeit des Auftretens von Wörtern, ganzen Phrasen
                oder spezifischen Zeichensätzen zu ermitteln. Sie ist
                beispielsweise hilfreich, wenn du überprüfen möchtest, ob
                Begriffe wie „room“, „bathroom“, „en suite“ etc. in
                Hotelzufriedenheitsbeschreibungen vorkommen und wie oft sie
                auftreten. Mit dieser Option kannst du die Überprüfung des
                Vorkommens einer bestimmten Zeichenkette aus einer
                vordefinierten Liste sowie deren Häufigkeit auswählen. Du kannst
                festlegen, ob die Groß-/Kleinschreibung der Zeichenkette
                berücksichtigt werden soll.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/string-count.png"
                  alt="Dialog 'String Count'"
                  style={{ width: "min(84vw, 60rem)", margin: "2rem 0 4rem 0" }}
                />
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h2>NEUE FEATURES IN IBM SPSS STATISTICS 29.0.2</h2>
            <h3>Allgemeine Verbesserungen</h3>
            <ul>
              <li>
                <strong>DATE EDITOR</strong> – Der neue{" "}
                <strong>Overview</strong>-Tab bietet grundlegende Informationen
                über die Variablen im Datensatz, zusammen mit Zusammenfassungen
                der Variablentypen, Messniveaus und fehlender Daten. Zusätzlich
                ermöglicht er den Zugriff auf Details einzelner Variablen
                mittels entsprechender Diagramme und
                Zusammenfassungsstatistiken, basierend auf den definierten
                Messniveaus der Variablen.
              </li>
            </ul>
            <hr />
            <h3>Neue Analytische Verfahren</h3>
            <ul>
              <li>
                <strong>PARAMETRISCHE SHARED FRAILTY-MODELLE</strong> – Ein
                neues analytisches Verfahren im Menü{" "}
                <strong>Survival Analysis</strong>. Diese Modelle werden zur
                Analyse von Überlebenszeitdaten eingesetzt, insbesondere bei
                wiederkehrenden Ereignissen. Sie gehen davon aus, dass die
                Überlebenszeit einer bekannten Verteilung folgt, und die
                Einführung eines Frailty-Faktors berücksichtigt zusätzliche
                Variabilität, die durch individuelle oder gruppenspezifische
                Faktoren entstehen kann, die in anderen Variablen nicht erfasst
                werden.
              </li>
              <li>
                <strong>PERCENTILE</strong> – Ein neues Dialogfenster für{" "}
                <strong>Perzentile</strong>, das im Menü{" "}
                <strong>Descriptive Statistics</strong> verfügbar ist,
                ermöglicht die Berechnung beliebiger Perzentile unter Verwendung
                einer von fünf verfügbaren Schätzmethoden. Diese Optionen sind
                auch über die <strong>Statistics</strong>-Schaltfläche im
                Verfahren <strong>Exploration</strong> verfügbar.
              </li>
            </ul>
            <hr />
            <h3>Verbesserungen für einzelne Verfahren</h3>
            <ul>
              <li>
                <strong>LINEARE REGRESSION</strong>
                <ul>
                  <li>
                    <strong>AUSWAHLKRITERIEN</strong> im Statistik-Fenster –
                    Ermöglicht die Ausgabe in der Zusammenfassung:
                    Akaike-Informationskriterium, Amemiyas Vorhersagekriterium,
                    Mallows' Vorhersagekriterium und das
                    Schwarz-Bayesian-Kriterium.
                  </li>
                  <li>
                    <strong>TOLERANZ</strong> im Options-Fenster – Ein
                    Toleranztest ermöglicht zu beurteilen, ob die Variablen die
                    Mindestanforderungen erfüllen, um in die
                    Regressionsgleichung aufgenommen zu werden, wobei ihre
                    Unabhängigkeit von anderen Variablen berücksichtigt wird.
                  </li>
                  <li>
                    <strong>
                      PRESS (Predicted Residual Sum of Squares) Residuen
                    </strong>{" "}
                    im Statistik-Fenster – Ermöglicht die Bewertung der
                    Anpassungsqualität des Regressionsmodells.
                  </li>
                </ul>
              </li>
              <li>
                <strong>YOUDEN-INDEX FÜR ROC-KURVEN</strong> – Ermöglicht die
                Bewertung der Klassifikation jedes Schnittpunkts der ROC-Kurve
                unter Berücksichtigung von Sensitivität und Spezifität.
              </li>
              <li>
                <strong>EXPORT VON RANDOM EFFECTS PREDICTIONS (EBLUPS)</strong>{" "}
                – Die Möglichkeit, den Inhalt von EBLUP-Ergebnistabellen in
                Datensätze oder .sav-Dateien in Mischmodellverfahren zu
                exportieren (
                <strong>
                  Analyse &gt; Gemischte Modelle &gt; Linear oder Generalized
                  Linear
                </strong>
                ).
              </li>
              <li>
                <strong>COX-REGRESSION</strong> – Das Fenster dieses Verfahrens
                zur Überlebenszeitanalyse wurde neu gestaltet und ermöglicht nun
                die Spezifikation und Berechnung mehrerer zeitabhängiger
                Kovariaten für Cox-Regression-Modelle.
              </li>
            </ul>
          </DIV>

          <DIV language="en" className="news-post">
            <h2>NEW PREDICTIVE SOLUTIONS FEATURES</h2>
            <h3>New windows for Predictive Solutions procedures</h3>
            For all 66 procedures, including 5 new ones, new dialog windows have
            been prepared, which now provide, among other things:
            <ul>
              <li>
                Sorting variables alphabetically, descending, ascending, or
                according to the assigned measurement level.
              </li>
              <li>Quickly switching between variable names and labels.</li>
              <li>Variable selection based on the measurement level.</li>
              <li>
                The ability to select all variables available in the procedure
                from the window interface.
              </li>
              <li>
                Indicating which fields of the procedure are required.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/split-data.png"
                  alt="Split Data Dialog"
                  style={{
                    width: "min(84vw, 50rem)",
                    margin: "2rem 0 4rem 0",
                  }}
                />
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>New types of visualization of results</h3>
            <ul>
              <li>
                <b>SCALE GRAPH</b>
                <br />- a special type of bar chart used for features measured
                on the same scale. This type of visualisation can be employed
                when we want to present a set of features on a single plot that
                have polarized values, such as "yes" and "no," or when the scale
                is more elaborate, ranging from "strongly agree" to "strongly
                disagree," for example. It can be used for both odd scales with
                a central (neutral) position and even scales. This type of
                visualisation is useful for illustrating data derived from
                scales such as Likert scales, semantic differentials, or Stapel
                scales.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/scale-graph.png"
                  alt="Scale Graph"
                  style={{ width: "min(84vw, 50rem)", margin: "1rem 0 4rem 0" }}
                />
              </li>
              <li>
                <b>CORRELATION MAP</b>
                <br />– this visualization is used to present the relationships
                between multiple pairs of features on a single plot which
                facilitates the analysis of relationships among a large number
                of variables. The strength of the relationship between pairs of
                features is depicted using colour saturation or a red-green
                gradient. For ease of interpretation, you can display on the
                plot correlation coefficient values, variable counts, and
                significance levels. The procedure allows for the presentation
                of one of four correlation measures: Pearson's r, r squared,
                Kendall's Tau-b, or Spearman's rho. The user can specify a
                threshold value for the significance level, making it easy to
                filter out statistically insignificant relationships between
                pairs of variables.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/correlation-map.png"
                  alt="Correlation Map"
                  style={{ width: "min(84vw, 50rem)", margin: "1rem 0 4rem 0" }}
                />
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>New procedures for data preparation</h3>
            <ul>
              <li>
                <b>SPLIT DATA</b> – allows for dividing a dataset into multiple
                subsets without the tedious selection of data subgroups and
                saving each subgroup file separately. For example, if we want to
                divide the data by regions, we simply specify the "region"
                feature, run the procedure, and new data files will be created
                at the specified location. Each file will represent data from
                one region, saved in .sav format. The procedure enables flexible
                management of file names based on label names and values or user
                preferences.
              </li>
              <li>
                <b>SPLIT TEXT</b>– allows for splitting a single text variable
                into multiple new variables. It is particularly useful when a
                variable may contain more than one value in a single record,
                such as a list of recently purchased products separated by
                commas. Text variable splitting can be done in two ways. The
                first method involves splitting according to a specified
                character or a custom text string entered by the user. The
                second option allows for splitting the variable according to a
                fixed width. The procedure will create new variables with names
                composed of the user-specified prefix and a counter.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/split-text.png"
                  alt="Split Text Dialog"
                  style={{ width: "min(84vw, 60rem)", margin: "2rem 0 4rem 0" }}
                />
              </li>
              <li>
                <b>STRING COUNT</b>
                <br />– this function is useful for analysing respondents'
                answers from open-ended questions or other texts to identify the
                frequency of occurrence of words, entire phrases, or specific
                character sets. It is helpful, for example, if we want to check
                whether terms like "room," "bathroom," "en suite," etc., appear
                in hotel satisfaction descriptions and how often they occur.
                Using this option, you can choose to check the occurrence of a
                specific string from a predefined list, as well as the frequency
                of occurrence of that sequence. The user can specify whether to
                consider the case sensitivity of the string.
                <br />
                <img
                  src="/img/news/ps-imago-pro-10/string-count.png"
                  alt="String Count Dialog"
                  style={{ width: "min(84vw, 60rem)", margin: "2rem 0 4rem 0" }}
                />
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h2>NEW FEATURES IN IBM SPSS STATISTICS 29.0.2</h2>
            <h3>General Improvements</h3>
            <ul>
              <li>
                <strong>DATE EDITOR</strong> – The new <strong>Overview</strong>{" "}
                tab provides basic information about variables in the data set,
                along with summaries of variable types, measurement levels, and
                missing data. Additionally, it allows access to details for
                individual variables using appropriate charts and summary
                statistics based on defined variable measurement levels.
              </li>
            </ul>
            <hr />
            <h3>New Analytical Procedures</h3>
            <ul>
              <li>
                <strong>PARAMETRIC SHARED FRAILTY MODELS</strong> – A new
                analytical procedure in the <strong>Survival Analysis</strong>{" "}
                menu. These models are used to analyze survival time data,
                especially in the case of recurrent events. They assume that the
                survival time follows a known distribution, and the introduction
                of a frailty factor accounts for additional variability that may
                arise from individual or group factors not accounted for in
                other variables.
              </li>
              <li>
                <strong>PERCENTILES</strong> – A new dialog box for{" "}
                <strong>Percentiles</strong> available in the{" "}
                <strong>Descriptive Statistics</strong> menu allows for the
                calculation of any percentiles using one of five available
                methods of estimation. These options are also available under
                the <strong>Statistics</strong> button in the{" "}
                <strong>Exploration</strong> procedure.
              </li>
            </ul>
            <hr />
            <h3>Improvements for Individual Procedures</h3>
            <ul>
              <li>
                <strong>LINEAR REGRESSION</strong>
                <ul>
                  <li>
                    <strong>SELECTION CRITERIA</strong> in the Statistics window
                    – Allows obtaining in the summary: Akaike Information
                    Criterion, Amemiya's Prediction Criterion, Mallows'
                    Prediction Criterion, and Schwarz Bayesian Criterion.
                  </li>
                  <li>
                    <strong>TOLERANCE</strong> in the Options window – A
                    tolerance test allows assessing whether the variables meet
                    the minimum requirements to be included in the regression
                    equation, considering their independence from other
                    variables.
                  </li>
                  <li>
                    <strong>
                      PRESS (Predicted Residual Sum of Squares) residuals
                    </strong>{" "}
                    in the Statistics window – Allows evaluating the fit quality
                    of the regression model.
                  </li>
                </ul>
              </li>
              <li>
                <strong>YOUDEN'S INDEX FOR ROC CURVES</strong> – Allows
                evaluating the classification of each cut point of the ROC
                curve, considering sensitivity and specificity.
              </li>
              <li>
                <strong>EXPORT RANDOM EFFECTS PREDICTIONS (EBLUPS)</strong> –
                The ability to export the contents of EBLUP result tables to
                datasets or .sav files in mixed model procedures (
                <strong>
                  Analysis &gt; Mixed Models &gt; Linear or Generalized Linear
                </strong>
                ).
              </li>
              <li>
                <strong>COX REGRESSION</strong> – The window of this survival
                analysis procedure has been redesigned, now allowing for the
                specification and calculation of multiple time-dependent
                covariates for Cox regression models.
              </li>
            </ul>
          </DIV>
        </>
      )}
    </>
  );
};

export default NewsPSImagoPro10;
